import { Position } from './Position';
export class Rotation {
    /**
     * @angle unit is rad
     */
    constructor(angle = 0) {
        this.type = 'Rotation';
        this._angle = angle;
    }
    static getAngle(pos, rotationPoint) {
        return Math.atan2(pos.x - rotationPoint.x, pos.y - rotationPoint.y) - Math.PI;
    }
    static rotatePoint(angle, pos, rotationPoint) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const newX = cos * (pos.x - rotationPoint.x) + sin * (pos.y - rotationPoint.y) + rotationPoint.x;
        const newY = cos * (pos.y - rotationPoint.y) - sin * (pos.x - rotationPoint.x) + rotationPoint.y;
        return new Position(newX, newY);
    }
    get angle() {
        return this._angle;
    }
    static convertFromRadToDegree(angle) {
        return (angle * -180) / Math.PI;
    }
    static convertFromDegreeToRad(angle) {
        return (angle * Math.PI) / -180;
    }
    set angle(angle) {
        if (Math.abs(angle) == Infinity) {
            throw 'Infinity is not a correct value';
        }
        this._angle = angle % (Math.PI * 2);
    }
    clone() {
        return new Rotation(this._angle);
    }
    static hydrate(data) {
        return new Rotation(data._angle);
    }
}
